import { useMemo } from 'react';
import { convertScreenWidth } from './helpers/convertScreenWidth';
import { calculateBreakpoint } from './helpers/calculateBreakpoint';
/**
 * Detect the the current breakpoint by window size
 * @private for internal use
 */
export function useDetectCurrentBreakpoint(options) {
    var breakpoints = options.breakpoints, breakpointUnit = options.breakpointUnit, guessedBreakpoint = options.guessedBreakpoint, defaultBreakpoint = options.defaultBreakpoint, screenSize = options.screenSize;
    var currentBreakpoint = useMemo(function () {
        if (screenSize.width) {
            // if we are on the client, we directly compose the breakpoint using window width
            var screenWidth = convertScreenWidth(screenSize.width, breakpointUnit);
            return calculateBreakpoint(screenWidth, breakpoints);
        }
        else if (guessedBreakpoint) {
            // use the breakpoint provided by SSR on server
            return calculateBreakpoint(guessedBreakpoint, breakpoints);
        }
        else {
            // use default breakpoint if no breakpoint from server is available
            return calculateBreakpoint(defaultBreakpoint, breakpoints);
        }
    }, [
        breakpointUnit,
        defaultBreakpoint,
        guessedBreakpoint,
        breakpoints,
        screenSize,
    ]);
    return currentBreakpoint;
}
//# sourceMappingURL=useDetectCurrentBreakpoint.js.map